import { props, not, any, curry, allPass, identity, length } from 'ramda'

export const anyProp = curry((fn, propNames, object) =>
  any(fn, props(propNames, object)),
)

export const anyPropMissing = curry(anyProp(not))

export const notEmptyOrFalsy = allPass([identity, length])
